import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAccount } from '../../app/account-context';

export const Logout = () => {
    const account = useAccount();

    useEffect(() => {
        if (!account.connected) return;
        account.logout();
    }, [account]);

    if (!account.connected) return <Navigate to="/login" />;
    return <></>;

};
